export function pendingCountBucket(count: number): string {
  if (count <= 1) return '1'
  if (count <= 5) return '2-5'
  if (count <= 20) return '6-20'
  return '21+'
}
